import AllTimeStatsPage from "./AllTimeStatsPage"

export default AllTimeStatsPage
